/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'
import { extrudeSettings } from '../../../../../utils/Functions';
import { params } from '../../../../../redux/reducers/reducer';

const BlackFrameHalfNetWindow = ({ width, height, trimWidth, glassTexture }) => {
    const trimColor = useMemo(() => {

        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])
    
    const windowWidth = width - trimWidth * 4
    const windowHeight = (height - trimWidth * 4) / 2

    const outTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2, height / 2);
        model.lineTo(width / 2, height / 2);
        model.lineTo(width / 2, -height / 2);
        model.lineTo(-width / 2, -height / 2);
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-width / 2 + trimWidth, height / 2 - trimWidth);
        hole.lineTo(width / 2 - trimWidth, height / 2 - trimWidth);
        hole.lineTo(width / 2 - trimWidth, -height / 2 + trimWidth);
        hole.lineTo(-width / 2 + trimWidth, -height / 2 + trimWidth);
        hole.closePath();

        model.holes.push(hole);

        return model;
    }, [width, height, trimWidth])

    const insideTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth, height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth, height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth, -height / 2 + trimWidth);
        model.lineTo(-width / 2 + trimWidth, -height / 2 + trimWidth);
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-width / 2 + (trimWidth * 2), height / 2 - (trimWidth * 2));
        hole.lineTo(width / 2 - (trimWidth * 2), height / 2 - (trimWidth * 2));
        hole.lineTo(width / 2 - (trimWidth * 2), -height / 2 + (trimWidth * 2));
        hole.lineTo(-width / 2 + (trimWidth * 2), -height / 2 + (trimWidth * 2));
        hole.closePath();
        
        model.holes.push(hole);

        return model;
    }, [width, height, trimWidth])
    
    const windowTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-windowWidth / 2, windowHeight / 2);
        model.lineTo(windowWidth / 2, windowHeight / 2);
        model.lineTo(windowWidth / 2, -windowHeight / 2);
        model.lineTo(-windowWidth / 2, -windowHeight / 2);
        model.closePath();
        
        const hole = new THREE.Path();
        hole.moveTo(-(windowWidth / 2 - trimWidth), (windowHeight / 2 - trimWidth));
        hole.lineTo((windowWidth / 2 - trimWidth), (windowHeight / 2 - trimWidth));
        hole.lineTo((windowWidth / 2 - trimWidth), -(windowHeight / 2 - trimWidth));
        hole.lineTo(-(windowWidth / 2 - trimWidth), -(windowHeight / 2 - trimWidth));
        hole.closePath();

        model.holes.push(hole);

        return model;
    
    }, [width, height, trimWidth])

    const railModel = useMemo(() => {
        let model = [];

        const railThickness = trimWidth / 5 * 4
        const railWidth = width - trimWidth * 6;
        const railHeight = height - trimWidth * 6;
        const distanceX = (railWidth - railThickness * 2) / 6;
        const distanceY = (railHeight - railThickness * 4) / 4;

        const horizontalUpperModel = new THREE.Shape();
        horizontalUpperModel.moveTo(-railWidth / 2, railThickness * 1 + distanceY * 1);
        horizontalUpperModel.lineTo(-railWidth / 2, railThickness * 2 + distanceY * 1);
        horizontalUpperModel.lineTo(railWidth / 2, railThickness * 2 + distanceY * 1);
        horizontalUpperModel.lineTo(railWidth / 2, railThickness * 1 + distanceY * 1);
        horizontalUpperModel.closePath();

        const verticalLeftModel = new THREE.Shape();
        verticalLeftModel.moveTo(-(distanceX + railThickness), trimWidth);
        verticalLeftModel.lineTo(-(distanceX + railThickness), railHeight / 2);
        verticalLeftModel.lineTo(-(distanceX), railHeight / 2);
        verticalLeftModel.lineTo(-(distanceX), trimWidth);

        const verticalRightModel = new THREE.Shape();
        verticalRightModel.moveTo((distanceX + railThickness), trimWidth);
        verticalRightModel.lineTo((distanceX + railThickness), railHeight / 2);
        verticalRightModel.lineTo((distanceX), railHeight / 2);
        verticalRightModel.lineTo((distanceX), trimWidth);

        model.push(horizontalUpperModel);
        
        model.push(verticalLeftModel);
        model.push(verticalRightModel);

        return model;
    }, [width, height, trimWidth])


    const glassModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(windowWidth / 2 - trimWidth), (windowHeight / 2 - trimWidth));
        model.lineTo((windowWidth / 2 - trimWidth), (windowHeight / 2 - trimWidth));
        model.lineTo((windowWidth / 2 - trimWidth), -(windowHeight / 2 - trimWidth));
        model.lineTo(-(windowWidth / 2 - trimWidth), -(windowHeight / 2 - trimWidth));
        model.closePath();
        return model;
    
    }, [width, height, trimWidth])
    
    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[outTrimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={'#1F1F1F'} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            <mesh name='inside-trim'>
                <extrudeGeometry args={[insideTrimModel, extrudeSettings(0.4)]} />
                <meshStandardMaterial color={'#1F1F1F'} side={THREE.DoubleSide} metalness={0.3} />
            </mesh>

            {new Array(2).fill("").map((_, index) =>
                <group key={`rail-model-${index}`} name='pattern-rail-model' position={[0, windowHeight * (index - 1), 0.1 + 0.1 * index]}>
                    <mesh name='rail'>
                        <extrudeGeometry args={[railModel, extrudeSettings(0.1)]} />
                        <meshStandardMaterial  color={'#242424'} side={THREE.DoubleSide} roughness={0.3} metalness={0.1} />
                    </mesh>
                </group>
            )}

           
            <>
                <group name='window-model' position={[0, Math.pow(-1, 0) * (-windowHeight / 2), 0.1 + 0.1 * 0]}>
                    <mesh name='glass-trim'>
                        <extrudeGeometry args={[windowTrimModel, extrudeSettings(0.1)]} />
                        <meshStandardMaterial color={'#242424'} side={THREE.DoubleSide} metalness={0.1}  />
                    </mesh>
                    <mesh name='glass' position={[0, 0, 0.01]}>
                        <extrudeGeometry args={[glassModel, extrudeSettings(0.08)]} />
                        <meshPhongMaterial color={'#1f1e1e'} side={THREE.DoubleSide}reflectivity={0.5} metalness={0.2} toneMapped={false} />                        
                    </mesh>
                </group>
                  <group name='window-model' position={[0, Math.pow(-1, 1) * (-windowHeight / 2), 0.1 + 0.1 * 1]}>
                    <mesh name='glass-trim'>
                        <extrudeGeometry args={[windowTrimModel, extrudeSettings(0.1)]} />
                        <meshStandardMaterial color={'#242424'} side={THREE.DoubleSide} metalness={0.1}  />
                    </mesh>
                    <mesh name='glass' position={[0, 0, 0.01]}>
                        <extrudeGeometry args={[glassModel, extrudeSettings(0.08)]} />                        
                        <meshPhongMaterial envMap={glassTexture}  side={THREE.DoubleSide}reflectivity={1}/>                        
                    </mesh>
                </group>
            </>
            
        </>
    )
}

export default BlackFrameHalfNetWindow